import { ITenant } from "models/configurations.models";
import { QueryAPIKey } from "utils/constants/api.constants";
import queries from "../../queries";

export const tenantsQueryConfig = {
  getTenants: {
    query: queries.tenants.tenants,
    queryKey: [QueryAPIKey.GetTenants],
    errorMessageKey: "getTenantsFailure",
    queryOptions: {
      select: ({ tenants }: { tenants: ITenant[] }): ITenant[] => tenants ?? [],
    },
  },
};
